import React, { createContext, useState, useContext, useEffect } from 'react';

// Create the context
const ProductsContext = createContext();

// Custom hook to use the products context
export const useProducts = () => useContext(ProductsContext);

// Provider component
export const ProductsProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        // Use the appropriate API URL based on environment
        const apiUrl = process.env.REACT_APP_NODE_ENV === 'dev'
          ? 'http://localhost:4242/api/products'
          : `${process.env.REACT_APP_BACKEND_URL}/api/products`;

        const response = await fetch(apiUrl);

        if (!response.ok) {
          throw new Error('Failed to fetch products');
        }

        const data = await response.json();
        setProducts(data.products);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching products:', err);
        setError(err.message);
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  // Provide the products data and state to consuming components
  return (
    <ProductsContext.Provider value={{ products, loading, error }}>
      {children}
    </ProductsContext.Provider>
  );
};

export default ProductsContext;
